/**
 * Mobile-only: neutralize jacklmoore zoom on #product-main-image.
 * theme.js calls $("#product-main-image").zoom() with defaults { touch: true }.
 * After the zoom image loads it binds touchstart.zoom / touchmove.zoom with
 * preventDefault(), which blocks native vertical page scroll.
 * Correct teardown is $el.trigger('zoom.destroy'), not $el.zoom('destroy').
 * Desktop zoom is unchanged. Layout / variants / thumbs are not touched.
 */
(function () {
  var MQ = '(max-width: 740px)';

  function isMobileProduct() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function patchZoom() {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.zoom) return;
    if (window.jQuery.fn.zoom.__cwMobilePatched) return;
    var original = window.jQuery.fn.zoom;
    window.jQuery.fn.zoom = function (arg) {
      if (isMobileProduct() && arg !== 'destroy') {
        return this;
      }
      return original.apply(this, arguments);
    };
    window.jQuery.fn.zoom.__cwMobilePatched = true;
  }

  function hasZoomTouch() {
    var el = document.getElementById('product-main-image');
    if (!el || !window.jQuery || !window.jQuery._data) return false;
    var ev = window.jQuery._data(el, 'events');
    return !!(ev && ev.touchstart && ev.touchstart.length);
  }

  function stripZoom() {
    if (!isMobileProduct() || !window.jQuery) return;
    patchZoom();
    var $el = window.jQuery('#product-main-image');
    if (!$el.length) return;
    $el.trigger('zoom.destroy');
    $el.off('.zoom');
    $el.find('.zoomImg').remove();
    $el.css({ overflow: '', position: '' });
  }

  function run() {
    if (!isMobileProduct()) return;
    patchZoom();
    stripZoom();
    var n = 0;
    var t = setInterval(function () {
      stripZoom();
      n += 1;
      if (!hasZoomTouch() || n > 50) {
        clearInterval(t);
      }
    }, 80);
  }

  var tries = 0;
  var wait = setInterval(function () {
    tries += 1;
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.zoom) {
      clearInterval(wait);
      window.jQuery(document).on('shopify:section:load', '.product-page', run);
      run();
    } else if (tries > 80) {
      clearInterval(wait);
    }
  }, 50);

  if (window.matchMedia) {
    var mq = window.matchMedia(MQ);
    if (mq.addEventListener) mq.addEventListener('change', run);
    else if (mq.addListener) mq.addListener(run);
  }
})();
